import React, { Component } from "react";

import axios from "axios";

import { Input, Button, Container, Row, Col, Card, CardBody } from "mdbreact";
import domain from "./domain";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: " syam",
      empcode: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  onSubmit = (e) => {
    e.preventDefault();
    let r = window.confirm(
      "Check your employee code & Username before submitting"
    );
    if (r) {
      const data = {
        empcode: this.state.empcode,
        username: this.state.username,
      };

      axios
        .request({
          method: "post",
          url: `${domain.DBServer}/send-password`,
          data: data,
        })
        .then((result) => {
          console.log(result.data);
          const { success, msg } = result.data;
          if (success === true) {
            alert(msg);
            this.props.history.replace(`/login`);
          } else {
            alert(msg);
          }
        })
        .catch((err) => {
          alert(err);
        });
    } else {
      return false;
    }
  };

  handleInputChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    console.log(value);
    this.setState({
      [name]: value,
    });
  }

  render() {
    return (
      <Container>
        <Row className="col-md-offset-5 col-centered">
          <Col md="12">
            <Card>
              <CardBody>
                <p className="h2 text-center mb-4">Forgot Password </p>
                <form onSubmit={this.onSubmit.bind(this)}>
                  <Input
                    label="Enter your Employee code"
                    id="empcode"
                    name="empcode"
                    group
                    type="text"
                    validate
                    onChange={this.handleInputChange}
                    required="required"
                  />
                  <Input
                    label="Enter your Username"
                    id="username"
                    name="username"
                    group
                    type="text"
                    validate
                    error="wrong"
                    success="right"
                    onChange={this.handleInputChange}
                    required="required"
                  />

                  <div className="text-center">
                    <Button className="btn btn-indigo" type="submit">
                      Submit
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
export default ForgotPassword;
